import { display, lighten, maxHeight, width } from "@mui/system";

const styles = (theme) => ({
  title: { fontWeight: "bold", fontSize: "20px" },
  paperContainer: {
    margin: "10px 0",
    p: 2,
    borderRadius: "16px",
  },
  switch: {
    width: 42,
    height: 26,
    padding: 0,
    "& .MuiSwitch-switchBase": {
      padding: 0,
      margin: 0.2,
      transitionDuration: "300ms",
      "&.Mui-checked": {
        transform: "translateX(16px)",
        color: "#fff",
        "& + .MuiSwitch-track": {
          backgroundColor: theme.palette.primary.main,
          opacity: 1,
          border: 0,
        },
        "&.Mui-disabled + .MuiSwitch-track": {
          opacity: 0.5,
        },
      },
      "&.Mui-focusVisible .MuiSwitch-thumb": {
        color: theme.palette.primary.main,
        border: "6px solid #fff",
      },
      "&.Mui-disabled .MuiSwitch-thumb": {
        color:
          theme.palette.mode === "dark"
            ? theme.palette.grey[600]
            : theme.palette.grey[100],
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: theme.palette.mode === "dark" ? 0.3 : 0.7,
      },
    },
    "& .MuiSwitch-thumb": {
      boxSizing: "border-box",
      width: 22,
      height: 22,
    },
    "& .MuiSwitch-track": {
      borderRadius: 26 / 2,
      backgroundColor:
        theme.palette.mode === "dark"
          ? lighten(theme.palette.colors.black.dark, 0.07)
          : theme.palette.colors.gray.medium,
      opacity: 1,
      transition: theme.transitions.create(["background-color"], {
        duration: 500,
      }),
    },
  },
  icon: {
    fontSize: 22,
    color: theme.palette.white.main,
  },
  titleSwitch: {
    fontWeight: 600,
    ml: 1,

    fontSize: "0.85rem",
    userSelect: "none",
  },
  paperDatagrid: {
    width: "100%",
    overflowX: "auto",
    backgroundColor: theme.palette.background.paper,
    borderRadius: "16px",
    height: "100%",
    maxHeight: "400px",
  },
  searchField: {
    width: "100%",
    maxWidth: 300,

    display: "flex",

    fontSize: "0.75rem", // diminui fonte geral
  },
  paperBody: {
    p: 2,
    borderRadius: "16px",
    display: "flex",
    flexDirection: "column",
    gap: 2,
  },
  subtitle: {
    fontWeight: "bold",
    fontSize: "14px",
    color: theme.palette.text.secondary,
    ml: 1,
  },
  containerInfoConfig: { display: "flex", gap: 1, width: "100%" },
  autocompleteInfoConfig: {
    width: "100%",
    maxWidth: 400,
  },
  containerHeader: {
    p: 1,
  },
  paperDescription: {
    p: 1,
    width: "100%",
    borderRadius: "8px",
    display: "flex",
    alignItems: "center",
  },
  boxActions: {
    width: "100%",
    display: "flex",
    justifyContent: "flex-end",
    mt: 2,
  },
});
export default styles;
